import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungUploadDaten
 * Metadaten für die Uploads bei der Schadenmeldung
 * Endpoints: /api/v2/versicherungen/fahrrad/v2/schaden, /api/schadenmeldungen/schutzbrief, /api/schadenmeldungen/aks, /api/schadenmeldungen/rrv, /api/schadenmeldungen/dokumentnachreichen
 */
export class SchadenmeldungUploadDatenApi extends BaseApiModel {
	constructor(initialProperties?: Partial<SchadenmeldungUploadDatenApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected fileId: string;
	/**
	 * Description: Id unter der die Datei im Uploadstore zu finden ist
	 * APIL Type: string
	 */
	get FileId(): string {
		return this.fileId;
	}

	/**
	 * Description: Id unter der die Datei im Uploadstore zu finden ist
	 * APIL Type: string
	 */
	set FileId(value: string) {
		this.fileId = value;
	}

	protected filename: string;
	/**
	 * Description: Name der Datei
	 * APIL Type: string
	 */
	get Filename(): string {
		return this.filename;
	}

	/**
	 * Description: Name der Datei
	 * APIL Type: string
	 */
	set Filename(value: string) {
		this.filename = value;
	}

	protected filesize: number;
	/**
	 * Description: Größe der Datei
	 * APIL Type: double
	 */
	get Filesize(): number {
		return this.filesize;
	}

	/**
	 * Description: Größe der Datei
	 * APIL Type: double
	 */
	set Filesize(value: number) {
		this.filesize = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): SchadenmeldungUploadDatenApi {
		return AppUtils.Helper.createFromMap(dataObject, SchadenmeldungUploadDatenApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.FileId = this.fileId;
		result.Filename = this.filename;
		result.Filesize = this.filesize;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}